/*
  Loads on every page. Single job: after any /cart/add request (theme, app, or
  third-party like Regios free-gift), re-fetch the cart drawer + cart icon
  sections and swap their HTML in place. No page reload, no drawer open/close.

  This exists because cart-options.js (which has its own /cart/add hook) only
  loads on /cart. This script fills the gap for all other pages.
*/
(function () {
  var REFRESH_DELAY_MS = 1500; // give third-party apps time to inject companion items
  var DEBOUNCE_MS = 600;       // collapse rapid add bursts into one refresh

  function getMiniCart() {
    return document.querySelector("mini-cart");
  }

  function refreshCartDrawerSections() {
    if (!getMiniCart()) return; // no drawer on this page
    fetch("/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble", {
      credentials: "same-origin"
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections) return;
        applySection("mini-cart", sections["mini-cart"]);
        applySection("cart-icon-bubble", sections["cart-icon-bubble"]);
        applySection("mobile-cart-icon-bubble", sections["mobile-cart-icon-bubble"]);
      })
      .catch(function () {});
  }

  function applySection(id, html) {
    var el = document.getElementById(id);
    if (!el || !html) return;
    var parsed = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(".shopify-section");
    if (parsed) el.innerHTML = parsed.innerHTML;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  var debouncedRefresh = debounce(refreshCartDrawerSections, DEBOUNCE_MS);

  function isCartAddUrl(url) {
    return typeof url === "string" && url.indexOf("/cart/add") !== -1;
  }

  // Monkey-patch fetch
  var originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function () {
      var args = arguments;
      var url = args[0] && args[0].url ? args[0].url : args[0];
      var p = originalFetch.apply(this, args);
      if (isCartAddUrl(url)) {
        p.then(function () { setTimeout(debouncedRefresh, REFRESH_DELAY_MS); })
         .catch(function () {});
      }
      return p;
    };
  }

  // Monkey-patch XMLHttpRequest for the occasional legacy code path
  var originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (isCartAddUrl(url)) {
        var prevHandler = this.onreadystatechange;
        this.onreadystatechange = function () {
          if (this.readyState === 4) {
            setTimeout(debouncedRefresh, REFRESH_DELAY_MS);
          }
          if (prevHandler) prevHandler.apply(this, arguments);
        };
      }
    } catch (e) { /* never break XHR */ }
    return originalXhrOpen.apply(this, arguments);
  };
})();
